import React from 'react'
import * as styles from './styles.module.scss'

const Container = ({ children }) => {
  return <div>{children}</div>
}

/**
 *掲載情報のコンポーネント
 */
export const Title = () => <div className={styles.TitleContent}>掲載商品</div>

/**
 *
 */
export const Content = () => (
  <Container>
    <Title />
  </Container>
)
